import React from 'react';
import { Button, Modal } from 'jd-library';
import styles from './commonStyle.scss';

const LessSpecModal = props => {
    return (
        <Modal
            settings={{
                modalId: 'ai-modals',
                variant: 'action',
                class: styles["ai-modals"],
            }}
            backdropStatic
            onHidden={props.onHidden}
        >
            <Modal.CloseIcon />
            <Modal.Header className={styles['modal-heading']}>Add Specifications</Modal.Header>
            <Modal.Body className={styles['modal-body']}>
                {`You're just ${props.count} more specs away from a meaningful AI generated description`}
            </Modal.Body>           
            <div className={styles['btn-holder']}>
                <Button 
                    onClick={() => {
                        window.history.back();
                    }}
                    children={'Add More Specifications'}    
                />
            </div>
        </Modal>
    )
}

export default LessSpecModal;